import { Component } from 'react';
import withCustomScrollbar from 'web/components/common/withCustomScrollbar';

@withCustomScrollbar({ visible: true })
class CustomScrollbar extends Component {
  componentDidMount() {
    this.setScrollPoint(this.props);
  }
  componentWillReceiveProps(nextProps) {
    if (this.props.scrollInit) {
      if (this.props.scrollInit !== nextProps.scrollInit) {
        this.setScrollPoint(nextProps);
      }
    }
  }
  componentDidUpdate(nextProps) {
    if (this.props.isPlayer) {
      const thisProps = this.props;
      const { scroll } = thisProps;
      const { el, handle } = scroll;
      const { scrollTo } = handle;
      if (
        el &&
        thisProps.scrollActiveData &&
        thisProps.scrollActiveParams &&
        thisProps.scrollActiveClassName
      ) {
        if (
          thisProps.scrollActiveData[thisProps.scrollActiveParams] !==
          nextProps.scrollActiveData[nextProps.scrollActiveParams]
        ) {
          const activeItem = document.querySelector(
            `.${nextProps.scrollActiveClassName}`,
          );

          if (activeItem) {
            scrollTo({
              top:
                el.wrap.scrollTop +
                activeItem.getBoundingClientRect().top -
                140,
            });
          }
        }
      }
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    const tProps = {
      isPlayer: this.props.isPlayer,
      scrollInit: this.props.scrollInit,
      scrollActiveClassName: this.props.scrollActiveClassName,
      scrollActiveParams: this.props.scrollActiveParams,
      scrollActiveData: this.props.scrollActiveData,
    };
    const nProps = {
      isPlayer: nextProps.isPlayer,
      scrollInit: nextProps.scrollInit,
      scrollActiveClassName: nextProps.scrollActiveClassName,
      scrollActiveParams: nextProps.scrollActiveParams,
      scrollActiveData: nextProps.scrollActiveData,
    };

    return (
      JSON.stringify(tProps) !== JSON.stringify(nProps) ||
      this.props.scroll !== nextProps.scroll ||
      this.props.children !== nextProps.children
    );
  }

  setScrollPoint = props => {
    const { scroll } = props;
    setTimeout(() => {
      scroll.handle.setPosition();
      scroll.handle.scrollTo(0);
    }, 0);
  };

  render() {
    return this.props.children;
  }
}

export default CustomScrollbar;
